<template>
  <div class="ordertask">
    <el-form :model="form_data" label-width="110px" ref="form_data" inline size='large'>
      <el-form-item label="商单标题" prop="cpx_order_name">
        <el-input v-model="form_data.cpx_order_name" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="商单创建人" prop="order_adid">
        <el-select v-model="form_data.order_adid" 
          filterable 
          clearable 
          remote 
          :remote-method="getAnyAdid" 
          placeholder="请选择">
          <el-option 
            v-for="(item, index) in any_options" 
            :key="index" 
            :label="item.user_name" 
            :value="item.adid"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="达人昵称" prop="klurid">
        <el-select v-model="form_data.klurid" 
          filterable 
          clearable 
          remote 
          :remote-method="getKolList" 
          placeholder="请选择">
          <el-option 
            v-for="(item, index) in kol_options" 
            :key="index" 
            :label="item.nickname" 
            :value="item.klurid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="达人平台" prop="type">
        <el-select v-model="form_data.type" placeholder="请选择" clearable>
          <el-option 
            v-for="(item, index) in platform_options" 
            :key="index" 
            :label="item.platform_name" 
            :value="item.klpmid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作状态" class="p-form-item" prop="status">
            <el-select v-model="form_data.status" clearable placeholder="请选择">
              <el-option v-for="item in status_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
      </el-form-item>
      <el-form-item label="商务对接人" class="p-form-item" prop="shangwu_adid_name">
        <el-input v-model="form_data.shangwu_adid_name" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="合作模式" prop="cspta">
        <el-select v-model="form_data.cspta" placeholder="请选择" clearable>
          <el-option 
            v-for="(item, index) in cspta_options" 
            :key="index" 
            :label="item.label" 
            :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="推广形式" prop="promote_type">
        <el-select v-model="form_data.promote_type" placeholder="请选择" clearable>
          <el-option 
            v-for="(item, index) in promote_options" 
            :key="index" 
            :label="item.label" 
            :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <div style="margin-bottom: 22px">
      <el-button size="medium" type='primary' 
        @click="pageData.page = 1,getData()" style="margin-left: 110px">搜索</el-button>
      <el-button size="medium" @click='clearAll'>重置</el-button>
    </div>
    <el-divider class="self-divider"></el-divider>
    <div class="btn-tab">
      <el-button class="page-btn-tab" :class="{ active:form_data.status === 0}" @click="handleClick()">全部({{ countObj.count_total }})</el-button>
      <el-button class="page-btn-tab" :class="{ active:form_data.status === 1}" @click="handleClick(1)">待添加至合作名单({{ countObj.count_1 }})</el-button>
      <el-button class="page-btn-tab" :class="{ active:form_data.status === 2}" @click="handleClick(2)">待上传采买报价({{ countObj.count_2 }})</el-button>
      <el-popover
        placement="top"
        trigger="hover"
        content="可联系业务同学确认报价哦">
        <el-button slot="reference" class="page-btn-tab" :class="{ active:form_data.status === 3}" @click="handleClick(3)">待确认报价({{ countObj.count_3 }})</el-button>
      </el-popover>
      <el-button class="page-btn-tab" :class="{ active:form_data.status === 6}" @click="handleClick(6)">待交付({{ countObj.count_6 }})</el-button>
      <el-button class="page-btn-tab" :class="{ active:form_data.status === 8}" @click="handleClick(8)">数据效果待审核({{ countObj.count_8 }})</el-button>
      <el-button class="page-btn-tab" :class="{ active:form_data.status === 9}" @click="handleClick(9)">合作完成({{ countObj.count_9 }})</el-button>
      <el-button class="page-btn-tab" :class="{ active:form_data.status === 10}" @click="handleClick(10)">终止合作({{ countObj.count_10 }})</el-button>
      <el-button class="page-btn-tab" :class="{ active:form_data.status === 11}" @click="handleClick(11)">已拒绝({{ countObj.count_11 }})</el-button>
    </div>
    <el-table :data="list_data"
      :header-cell-style="{background: '#f9f9f9', color: '#333', fontSize: '14px', fontWeight: 'normal'}"
      :cell-style="{color:'#666', fontSize: '14px'}">
      <el-table-column label="达人信息">
        <template slot-scope="scope">
          <div>昵称：{{ scope.row.nickname }}</div>
          <div>平台：{{ scope.row.type_name }}</div>
          <div>粉丝数：{{ scope.row.fans }}</div>
          <div>合作模式：
            <span class="daren-tag" v-if="scope.row.cps === 2">CPS</span>
            <span class="daren-tag" v-if="scope.row.cpt_recommended === 2">CPT种草</span>
            <span class="daren-tag" v-if="scope.row.cpt_goods === 2">CPT带货</span>
            <span class="daren-tag" v-if="scope.row.cpa === 2">CPA</span>
            <span class="daren-tag" v-if="scope.row.cpc === 2">CPC</span>
          </div>
          <div>推广形式：
            <span class="daren-tag" v-if="scope.row.promote_video === 2">短视频</span>
            <span class="daren-tag" v-if="scope.row.promote_live === 2">直播混播</span>
            <span class="daren-tag" v-if="scope.row.promote_live_special === 2">直播专场</span>
            <span class="daren-tag" v-if="scope.row.promote_other === 2">其他(图文等)</span>
          </div>
          <!-- <div>媒介对接人：{{ scope.row.adid_name }}</div>
          <div>运营负责人：{{ scope.row.operator_adid_name }}</div> -->
          <div>
            <el-link
              type="primary" 
              :underline="false" 
              @click="media_questions_obj.klurid = scope.row.klurid, 
                media_questions_obj.media_questions_flag = true">达人采访记录</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商单信息">
        <template slot-scope="scope">
          <div>标题：{{ scope.row.cpx_order_name }}
            <span class="p-color-succ" v-if="scope.row.check_status === 1">进行中</span>
            <span class="p-color-danger" v-if="scope.row.check_status === 2">项目失败 </span>
            <el-tooltip placement="top" v-if="scope.row.check_status === 2">
              <div slot="content" class="w-500">{{scope.row.check_status_reason}}</div>
              <i class="el-icon-warning p-color-danger"></i>
              <!-- <span class="p-circle">!</span> -->
            </el-tooltip>
            <span class="p-color-succ" v-if="scope.row.check_status === 3">项目完成</span>
            <span :class="[scope.row.sign_up_time_status=='报名中'?'p-color-succ':'',scope.row.sign_up_time_status=='已截止'?'p-color-danger':'']" 
              v-if="scope.row.sign_up_time_status=='报名中'">·{{scope.row.sign_up_time_status}}</span>
          </div>
          <div>预计推广时间：</div>
          <div>{{scope.row.expect_begin_time?scope.row.expect_begin_time.slice(0,10).replace(/\-/g,"."):''}}~{{scope.row.expect_end_time?scope.row.expect_end_time.slice(0,10).replace(/\-/g,"."):''}}</div>
          <div>商务对接人：{{scope.row.shangwu_adid_name}}</div>
          <!-- <div>合作模式：
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.cps === 2">CPS</span>
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.cpt_recommended === 2">CPT种草</span>
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.cpt_goods === 2">CPT带货</span>
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.cpa === 2">CPA</span>
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.cpc === 2">CPC</span>
          </div>
          <div>推广模式：
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.promote_video === 2">短视频</span>
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.promote_live === 2">直播混播</span>
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.promote_live_special === 2">直播专场</span>
            <span class="sd-tag" v-if="scope.row.order && scope.row.order.promote_other === 2">其他(图文等)</span>
          </div>
          <div>
            <el-tooltip placement="top">
              <div slot="content" class="w-500">{{scope.row.expect_payment}}</div>
              <div class="lin1">预估账期：{{scope.row.expect_payment}}</div>
            </el-tooltip>
          </div>
          <div>结算方式：{{ scope.row.settlement_source === 1 ? '联盟（星任务/京任务）' : '非联盟（合同等）' }}</div>
          <div>商单创建人：{{ scope.row.order_adid_name }}</div> -->
        </template>
      </el-table-column>
      <!-- <el-table-column label="带货商品" width="180">
        <template slot-scope="scope">
          <div>达人带货任务：{{ scope.row.kol_goods_count.total ?scope.row.kol_goods_count.total: 0 }}个</div>
          <div>【待发货】{{ scope.row.kol_goods_count.sending ? scope.row.kol_goods_count.sending: 0 }}个</div>
          <div>【待收货】{{ scope.row.kol_goods_count.receiving ? scope.row.kol_goods_count.receiving: 0 }}个</div>
          <div>【待交付】{{ scope.row.kol_goods_count.received ? scope.row.kol_goods_count.received: 0 }}个</div>
          <div>【合作成功】{{ scope.row.kol_goods_count.succ ? scope.row.kol_goods_count.succ: 0 }}个</div>
          <div>【合作失败】{{ scope.row.kol_goods_count.stopped ? scope.row.kol_goods_count.stopped: 0 }}个</div>
        </template>
      </el-table-column> -->
      <el-table-column label="商单及带货商品" width="180">
        <template slot-scope="scope">
          <div>合计：{{ scope.row.order_goods_count.total }}(上架{{ scope.row.order_goods_count.confirm ? scope.row.order_goods_count.confirm: 0 }}下架{{ scope.row.order_goods_count.cancel ? scope.row.order_goods_count.cancel: 0 }})</div>
          <div>【待分配】{{ scope.row.order_goods_count.to_assign }}</div>
          <div>【待审核】{{ scope.row.order_goods_count.to_check }}</div>
          <div>【审核通过】{{ scope.row.order_goods_count.checked_yes }}</div>
          <div>【审核不通过】{{ scope.row.order_goods_count.checked_no }}</div>
          <div>达人带货任务：{{ scope.row.kol_goods_count.total ?scope.row.kol_goods_count.total: 0 }}个</div>
          <div>【待发货】{{ scope.row.kol_goods_count.sending ? scope.row.kol_goods_count.sending: 0 }}个</div>
          <div>【待收货】{{ scope.row.kol_goods_count.receiving ? scope.row.kol_goods_count.receiving: 0 }}个</div>
          <div>【待交付】{{ scope.row.kol_goods_count.received ? scope.row.kol_goods_count.received: 0 }}个</div>
          <div>【合作成功】{{ scope.row.kol_goods_count.succ ? scope.row.kol_goods_count.succ: 0 }}个</div>
          <div>【合作失败】{{ scope.row.kol_goods_count.stopped ? scope.row.kol_goods_count.stopped: 0 }}个</div>
        </template>
      </el-table-column>
      <el-table-column label="时间" width="255">
        <template slot-scope="scope">
          <div>状态：
            <span class="p-color-succ" v-if="scope.row.status==1">待添加至合作名单</span>
            <span class="p-color-succ" v-if="scope.row.status==2">待上传采买报价
              <el-tooltip placement="top" v-if="scope.row.reject_reason">
                <div slot="content" class="w-500">{{scope.row.reject_reason}}</div>
                <i class="p-color-succ el-icon-question"></i>
              </el-tooltip>
            </span>
            <span class="p-color-succ" v-if="scope.row.status==3">待确认报价</span>
            <span class="p-color-succ" v-if="scope.row.status==6">待交付</span>
            <span class="p-color-succ" v-if="scope.row.status==8">效果数据待审核</span>
            <span class="p-color-succ" v-if="scope.row.status==9">合作完成</span>
            <span class="p-color-danger" v-if="scope.row.status==10">终止合作 
              <el-tooltip placement="top">
                <div slot="content" class="w-500">{{scope.row.stop_reason}}</div>
                <i class="p-color-danger el-icon-question"></i>
              </el-tooltip>
            </span>
            <span class="p-color-danger" v-if="scope.row.status==11">已拒绝
              <el-tooltip placement="top">
                <div slot="content" class="w-500">{{scope.row.delete_remark}}</div>
                <i class="p-color-danger el-icon-question"></i>
              </el-tooltip>
            </span>
            <span class="p-color-succ" v-if="scope.row.check_complete ==1"> · 达标</span>
            <span class="p-color-danger" v-if="scope.row.check_complete ==2">
              <el-tooltip placement="top">
                <div slot="content" class="w-500">{{scope.row.refuse_reason}}</div>
                <span> · 不达标 <i class="el-icon-question"></i></span>
              </el-tooltip>
            </span>
          </div>
          <div>创建：{{ scope.row.create_time }}</div>
          <div>达人档期：
            <div>{{scope.row.kol_time_begin?scope.row.kol_time_begin.slice(0,10).replace(/\-/g,"."):''}} ~
            {{scope.row.kol_time_end?scope.row.kol_time_end.slice(0,10).replace(/\-/g,"."):''}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button class="btn" size="medium" type="text" @click="toOrderDetail(scope.row)">查看详情</el-button>
          <el-button class="btn" size="medium" type="text" v-if="scope.row.status === 1 || scope.row.status === 11" @click="showKolIsSelect(scope.row, 2)">选择添加</el-button>
          <el-button class="btn" size="medium" type="text" v-if="scope.row.status === 1" @click="showKolIsSelect(scope.row, 1)">拒绝添加</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
    <!-- 选择或拒绝 -->
    <kolisselect v-if='kol_select_info.kol_isSelect_flag' :kol_select_info='kol_select_info' @kolIsSelectClose='kolIsSelectClose'></kolisselect>
    <!-- 达人采访记录 -->
    <mediaquestions v-if="media_questions_obj.media_questions_flag" :media_questions_obj="media_questions_obj"></mediaquestions>
  </div>
</template>

<script>
import pagePagination from "@/components/page_pagination.vue"
import kolisselect from "@/components/cpx/kol_is_select.vue";
import mediaquestions from "@/components/cpx/media_questions.vue"
export default {
  name: "ordertask",
  components: {
    pagePagination,
    mediaquestions,
    kolisselect
  },
  data() {
    return {
      kol_select_info:{
        kol_isSelect_flag:false,
        type:'',
        cxdlid:'',
      },
      media_questions_obj: {
        media_questions_flag: false,
        klurid: "",
      },
      pageData: {
        count: 0,
        page: 1,
        offset: 5
      },
      any_options: [],
      kol_options: [],
      platform_options: [],
      // cspta_options: [
      //   { label: 'CPS', value: 1 },
      //   { label: 'CPT种草', value: 2 },
      //   { label: 'CPT带货', value: 3 },
      //   { label: 'CPA', value: 4 },
      //   { label: 'CPC', value: 5 },
      // ],
      // promote_options: [
      //   { label: '短视频', value: 1},
      //   { label: '直播混播', value: 2},
      //   { label: '直播专场', value: 4},
      //   { label: '其他(图文等)', value: 3},
      // ],
      form_data: {
        status: "",
        cpx_order_name: "",
        // order_adid: "",
        klurid: "",
        type: "",
        shangwu_adid:"",
        status:"",
        shangwu_adid_name:""
        // cspta: "",
        // promote_type: ""
      },
      status_options: [
        { label: "待添加至合作名单", value: 1 },
        { label: "待上传采买报价", value: 2 },
        { label: "待确认报价", value: 3 },
        { label: "待交付", value: 6 },
        { label: "效果数据待审核", value: 8 },
        { label: "合作完成", value: 9 },
        { label: "终止合作", value: 10 },
        { label: "已拒绝", value: 11 },
        { label: "待调整对外报价", value: 12 },
      ],
      list_data: [{
        order_goods_count: "",
        kol_goods_count: ""
      }],
      apiUrl: {
        getAdidList: "/home/getAdidList",  // 商单创建人
        getKolUserList: "/home/getKolUserList",  // 达人列表
        getKolPlatformList: "/home/getKolPlatformList",  // 达人平台
        cpxDealList: "/home/cpxDealList"  // 获取列表
      },
      countObj: {
        count_total: 0,
        count_1: 0,
        count_2: 0,
        count_3: 0,
        count_6: 0,
        count_8: 0,
        count_9: 0,
        count_10: 0,
        count_11: 0
      }
    }
  },
  created() {
    this.getKolPlatformList();
    this.getData();
  },
  watch: {},
  methods: {
    // 商单创建人列表
    getAnyAdid(name){
      this
        .$http({
          method: "GET",
          url: this.apiUrl.getAdidList,
          params: { name: name}
        })
        .then(res => {
          if (res.code == 1) {
            this.any_options = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 达人列表
    getKolList(name){
      this
        .$http({
          method: "GET",
          url: this.apiUrl.getKolUserList,
          params: { nickname: name}
        })
        .then(res => {
          if (res.code == 1) {
            this.kol_options = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 达人平台列表
    getKolPlatformList(){
      this
        .$http({
          method: "GET",
          url: this.apiUrl.getKolPlatformList
        }).then(res => {
          if (res.code == 1) {
            this.platform_options = res.data.list
          } else {
            this.$message.error(res.msg)
          }
        });
    },
    // 获取列表信息
    getData() {
      let data = this.form_data;
      data.page = this.pageData.page;
      data.offset = this.pageData.offset;
      this
        .$http({
          method: "GET",
          url: this.apiUrl.cpxDealList,
          params: data
        })
        .then(res => {
          if (res.code === 1 && res.data) {
            this.list_data = res.data || [];
            this.pageData.count = res.count || 0;
            this.countObj = res;
          } else {
            this.list_data = [];
            this.pageData.page = 1;
            this.pageData.count = 0;
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    toOrderDetail(row) {
      this.$router.push({
        path: "/my/ordertask/ordertaskdetail",
        query: {
          cxdlid: row.cxdlid
        }
      })
    },
    // 切换条件
    handleClick(val) {
      this.clearAll();
      this.form_data.status = val;
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.getData();
    },
    // 重置 
    clearAll(){
      this.$refs["form_data"].resetFields();
      this.form_data.cspta = "";
      this.form_data.promote_type = "";
      // this.form_data.status = "";
      this.pageData.page = 1;
      this.getData();
    },
    showKolIsSelect(row, type){
      this.kol_select_info.kol_isSelect_flag = true
      this.kol_select_info.type = type
      this.kol_select_info.cxdlid = row.cxdlid
    },
    kolIsSelectClose(data){
      this.getData();
    }
  }
}
</script>

<style scoped>
.w-200 {
  width: 203px;
}
.btn {
  margin: 0;
}
.w-500 {
  max-width: 500px;
}
.lin1 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.self-divider {
  margin: 20px 0;
  background-color: #f4f4f4;
}
.btn-tab {
  margin-bottom: 10px;
}
</style>
<style>
.ordertask .el-table td, 
.ordertask .el-table th {
  vertical-align: top !important;
}
</style>